// extracted by mini-css-extract-plugin
module.exports = {"re_login":"LoginModal_re_login__3PFOl","center_form_logo":"LoginModal_center_form_logo__2yUL1","title":"LoginModal_title__16WD0","title_sub":"LoginModal_title_sub__3tUgh"};